export default __webpack_public_path__ + "static/media/lesarcs-3x.dbf29802.webp";